'use strict';
import React from 'react';
import { Navigate } from 'react-router-dom';
import useFeatureAccess from '../hooks/useFeatureAccess';

export default function RequireFeature({ featureKey, children, redirectTo = '/dashboard' }) {
  const { loading, hasFeature } = useFeatureAccess();
  if (loading) return null;
  if (!hasFeature(featureKey)) {
    return <Navigate to={redirectTo} replace />;
  }
  return <>{children}</>;
}


